import { FlowWalletConnectors as FlowWalletConnectors$1 } from '@dynamic-labs/flow';

const FlowWalletConnectors = (props) => [...FlowWalletConnectors$1(props)];

export { FlowWalletConnectors };
